import { KeepAlive } from 'vue';

export default [
  {
    // 체육시설
    path: 'spfc',
    redirect: { name: 'spfcHome' },
    children: [
      {
        path: 'home',
        name: 'spfcHome',
        meta: { layout: 'default' },
        component: () => import('@/pages/resvMng/spfc/Home.vue')
      },
      /** 예약관리 */
      {
        path: 'rsvt-mng',
        redirect: { name: 'SpfcRsvtMngList' },
        children: [
          {
            path: 'list',
            name: 'SpfcRsvtMngList',
            meta: { menu: 'spfc', keepAlive: true },
            component: () => import('@/pages/resvMng/spfc/rsvtMng/RsvtMngListView.vue')
          },
          {
            path: 'add',
            name: 'SpfcRsvtMngInsert',
            meta: { menu: 'spfc', keepAlive: false },
            component: () => import('@/pages/resvMng/spfc/rsvtMng/RsvtMngInsertView.vue')
          },
          {
            path: 'modify/:ptFcltRsvtId',
            name: 'SpfcRsvtMngUpdate',
            meta: { menu: 'spfc', keepAlive: false },
            component: () => import('@/pages/resvMng/spfc/rsvtMng/RsvtMngUpdateView.vue'),
            props: true
          },
          // 공통 팝업 사용 (resvMng/common/popup)
          {
            path: 'payment-popup',
            name: 'SpfcRsvtPaymentPopup',
            meta: { menu: 'spfc', keepAlive: false, layout: 'blank' },
            component: () => import('@/pages/resvMng/common/popup/PaymentPopup.vue'),
            props: (route) => ({
              rsvtType: 'spfc',
              rsvtNo: route.query.ptFcltRsvtId || route.query.rsvtNo
            })
          },
          {
            path: 'payment-history-popup',
            name: 'SpfcRsvtPaymentHistoryPopup',
            meta: { menu: 'spfc', keepAlive: false, layout: 'blank' },
            component: () => import('@/pages/resvMng/common/popup/PaymentHistoryPopup.vue'),
            props: (route) => ({
              rsvtType: 'spfc',
              rsvtNo: route.query.ptFcltRsvtId || route.query.rsvtNo
            })
          },
          {
            path: 'manual-receipt-popup',
            name: 'SpfcRsvtManualReceiptPopup',
            meta: { menu: 'spfc', keepAlive: false, layout: 'blank' },
            component: () => import('@/pages/resvMng/common/popup/ManualReceiptPopup.vue'),
            props: (route) => ({
              rsvtType: 'spfc',
              rsvtNo: route.query.ptFcltRsvtId || route.query.rsvtNo
            })
          },
        ]
      },
      /** 예약현황관리 */
      {
        path: 'rsvt-cur-mng',
        redirect: { name: 'SpfcRsvtCurMngList' },
        children: [
          {
            path: 'list',
            name: 'SpfcRsvtCurMngList',
            meta: { menu: 'spfc', keepAlive: true },
            component: () => import('@/pages/resvMng/spfc/rsvtCurMng/RsvtCurMngListView.vue')
          },
          {
            path: 'rsvt-info-popup',
            name: 'SpfcRsvtInfoPopup',
            meta: { menu: 'spfc', keepAlive: false, layout: 'blank' },
            component: () => import('@/pages/resvMng/spfc/rsvtCurMng/components/RsvtInfoPopup.vue')
          }
        ]
      },
      /** 예약제한관리 */
      {
        path: 'rsvt-lmt-mng',
        redirect: { name: 'SpfcRsvtLmtMngList' },
        children: [
          {
            path: 'list',
            name: 'SpfcRsvtLmtMngList',
            meta: { menu: 'spfc', keepAlive: true },
            component: () => import('@/pages/resvMng/spfc/rsvtLmtMng/RsvtLmtMngListView.vue')
          }
        ]
      },
      {
        //접수오류 체크
        path: 'apply-err-chk',
        redirect: { name: 'ApplyErrChkList' },
        children: [
          {
            path: 'list',
            name: 'ApplyErrChkList',
            meta: { menu: 'applyErrChk', keepAlive: true },
            component: () => import('@/pages/resvMng/spfc/applyErrChk/ApplyErrChkListView.vue')
          }
        ]
      },
      {
        // 시설분류 관리
        path: 'fclt-cate',
        redirect: { name: 'FcltClsfMngList' },
        children: [
          {
            path: 'list',
            name: 'FcltClsfMngList',
            meta: { menu: 'fclt-cate', keepAlive: true },
            component: () => import('@/pages/resvMng/spfc/fcltClsfMng/FcltClsfMngListView.vue')
          },
          {
            path: 'add',
            name: 'FcltClsfMngInsert',
            meta: { menu: 'fclt-cate', keepAlive: false },
            component: () => import('@/pages/resvMng/spfc/fcltClsfMng/FcltClsfMngInsertView.vue')
          },
          {
            path: 'modify/:ptFcltClsfId',
            name: 'FcltClsfMngUpdate',
            meta: { menu: 'fclt-cate', keepAlive: false },
            component: () => import('@/pages/resvMng/spfc/fcltClsfMng/FcltClsfMngUpdateView.vue'),
            props: true
          },
          {
            path: 'fclt-cate-shop-popup',
            name: 'FcltClsfMngShopPopup',
            meta: { menu: 'spfc', layout: 'blank' ,keepAlive: false },
            component: () => import('@/pages/resvMng/spfc/fcltClsfMng/components/FcltClsfMngShopPopup.vue'),
            props: (route) => {
              const usePm = route.query.usePostMessage
              const usePostMessage =
                usePm === undefined ? true : String(usePm).toLowerCase() === 'true'
              return { usePostMessage }
            }
          }
        ]
      },
      {
        // 시설 관리
        path: 'fclt-mng',
        redirect: { name: 'FcltMngList' },
        children: [
          {
            path: 'list',
            name: 'FcltMngList',
            meta: { menu: 'fclt', keepAlive: true },
            component: () => import('@/pages/resvMng/spfc/fcltMng/FcltMngListView.vue')
          },
          {
            path: 'add',
            name: 'FcltMngInsert',
            meta: { menu: 'fclt', keepAlive: false },
            component: () => import('@/pages/resvMng/spfc/fcltMng/FcltMngInsertView.vue')
          },
          {
            path: 'modify/:ptFcltId',
            name: 'FcltMngUpdate',
            meta: { menu: 'fclt', keepAlive: false },
            component: () => import('@/pages/resvMng/spfc/fcltMng/FcltMngUpdateView.vue'),
            props: (route) => ({ ...route.params, ...route.query })
          },
          {
            path: 'fclt-mng-oper-hr-popup',
            name: 'FcltMngOperHrPopup',
            meta: { menu: 'spfc', layout: 'blank' ,keepAlive: false },
            component: () => import('@/pages/resvMng/spfc/fcltMng/components/FcltMngOperHrPopup.vue'),
            props: true
          },
          {
            path: 'fclt-mng-oper-hr-grp-popup',
            name: 'FcltMngOperHrGrpPopup',
            meta: { menu: 'spfc', layout: 'blank' ,keepAlive: false },
            component: () => import('@/pages/resvMng/spfc/fcltMng/components/FcltMngOperHrGrpPopup.vue'),
            props: true
          },


        ]
      },
      {
        // 일별예약현황
        path: 'daily-rsrvt',
        redirect: { name: 'DailyRsrvtList' },
        children: [
          {
            path: 'list',
            name: 'DailyRsrvtList',
            meta: { menu: 'dailyRsrvt', keepAlive: true },
            component: () => import('@/pages/resvMng/spfc/dailyRsrvt/DailyRsrvtListView.vue')
          }
        ]
      }
    ]
  }
]
